<template>
  <div>
    <transition name="default">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  name: "NoContainer"
}
</script>

<style scoped lang="scss">

</style>